import queryClient from '../../../ReactQuery/client';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { LicensingPolicy } from '../../../../typings/api';
import type { LicensingRule, PolicyId } from '../../../types';

type BulkCreateRequest = { newRules: Array<Partial<LicensingRule>>; };

type CreatePolicyRulesParams = {
  policyId: PolicyId;
  newRules: BulkCreateRequest;
};

const postPolicyRules = ({ policyId, newRules }: CreatePolicyRulesParams) => {
  return post<BulkCreateRequest, LicensingPolicy | undefined>(`/api/policies/${policyId}/rules/bulk`, newRules);
};

/**
 * hook for creating many new licensing policy rules
 */
export default function useCreatePolicyRules() {
  return useToastedMutation({
    mutationFn: (params: CreatePolicyRulesParams) => postPolicyRules(params),
    errorToastMessage: 'Failed to create rules',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['policy'] });
    },
  });
}
